import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Security2(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Security2", sx, viewBox, children: [
    /* @__PURE__ */ jsx("path", { d: "M27.75 8.25h-24v31.5h24V8.25Z", fill: theme.vars.palette.secondary.main }),
    /* @__PURE__ */ jsx("path", { d: "M24.75 2.25h-18c-1.65 0-3 1.35-3 3v3h24v-3c0-1.65-1.35-3-3-3Z", fill: theme.vars.palette.primary.light }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M17.25 6h-3c-.45 0-.75-.3-.75-.75s.3-.75.75-.75h3c.45 0 .75.3.75.75s-.3.75-.75.75Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M24.75 45.75h-18c-1.65 0-3-1.35-3-3v-3h24v3c0 1.65-1.35 3-3 3Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M17.25 43.5h-3c-.45 0-.75-.3-.75-.75s.3-.75.75-.75h3c.45 0 .75.3.75.75s-.3.75-.75.75Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M39 30c-2.775 0-5.1 1.95-5.775 4.5H21.75V33c0-.825-.675-1.5-1.5-1.5s-1.5.675-1.5 1.5v1.5H16.5v-3c0-.825-.675-1.5-1.5-1.5s-1.5.675-1.5 1.5v3h-2.25c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5h21.975c.675 2.55 3 4.5 5.775 4.5 3.3 0 6-2.7 6-6s-2.7-6-6-6Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M40.5 38.25c1.2426 0 2.25-1.0074 2.25-2.25s-1.0074-2.25-2.25-2.25-2.25 1.0074-2.25 2.25 1.0074 2.25 2.25 2.25Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M15.75 27.75c4.5563 0 8.25-3.6937 8.25-8.25s-3.6937-8.25-8.25-8.25S7.5 14.9437 7.5 19.5s3.6937 8.25 8.25 8.25Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M18.7495 17.2501c0-1.875-1.725-3.375-3.675-2.925-1.05.225-1.95 1.125-2.25 2.25-.3 1.275.225 2.4 1.05 3.075l-.975 4.275c-.075.45.225.9.75.9h4.125c.45 0 .825-.45.75-.9l-.975-4.275c.75-.6 1.2-1.425 1.2-2.4Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
Security2.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Security2"
};
validateTidalLicense();
export {
  Security2
};
//# sourceMappingURL=Security2.js.map
